import { ControlValueAccessor } from '@angular/forms';

export class ValueAccessorBase<T> implements ControlValueAccessor {
  private innerValue: T;
  public onChange = _ => {};
  public onTouch = () => {};
  public onFormat = (value: T): T => value;

  get value(): T {
    return this.onFormat(this.innerValue);
  }

  set value(value: T) {
    if (this.innerValue !== value) {
      this.innerValue = value;
      this.onChange(value);
    }
  }

  writeValue(value: T) {
    this.innerValue = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  registerFormatter(fn: (t: T) => T) {
    this.onFormat = fn;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/input/value-accessor-base.ts